import React from 'react';
import Navbar from './components/Navbar'
import Gym from './components/Gym'
import Footer from './components/Footer'

function App() {
  return (
    <div>
      <Navbar />
      <Gym />
      <Footer />
    </div>
  );
}

export default App;
